import { render, staticRenderFns } from "./AddSubCategory.vue?vue&type=template&id=3602cbc8&scoped=true&"
import script from "./AddSubCategory.vue?vue&type=script&lang=js&"
export * from "./AddSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddSubCategory.vue?vue&type=style&index=0&id=3602cbc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3602cbc8",
  null
  
)

export default component.exports